import '../sass/card-carousel.scss';

const noMotionPreference = window.matchMedia('(prefers-reduced-motion: no-preference)');

(() => {
    const swiperScript = document.querySelector('#boomspace-theme-swiper-js');
    const $blocks = document.querySelectorAll('.card-carousel');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const $slider = $block.querySelector('.card-carousel__carousel');
        const $navigationPrevious = $block.querySelector('.card-carousel__navigation-button--previous');
        const $navigationNext = $block.querySelector('.card-carousel__navigation-button--next');

        const initCarousel = () => {
            if (!$slider) return;

            new Swiper($slider, {
                keyboard: {
                    enabled: true,
                    onlyInViewport: true
                },
                spaceBetween: 20,
                breakpoints: {
                    768: {
                        spaceBetween: 40
                    }
                },
                navigation: {
                    prevEl: $navigationPrevious,
                    nextEl: $navigationNext
                },
                pagination: {
                    el: '.card-carousel__pagination',
                    clickable: true
                },
                speed: noMotionPreference.matches ? 300 : 0,
                slidesPerView: 'auto',
            });
        };

        if (typeof Swiper !== 'undefined') { 
            initCarousel();
        } else {
            swiperScript.addEventListener('load', () => {
                initCarousel();
            });
        }
    });
})();
